import React from 'react';
import { Layout } from '~common/Layout';
import { CLAIM_US_TYPES } from '~features/claimer';
import { poolsConfigById } from '~features/pools';
import { ClaimPage } from '~features/pools/pages/ClaimPage';

export default function Claim({ id, chain }: { id: string; chain: string }) {
  const pool = poolsConfigById[id] || poolsConfigById[id.toLowerCase()];

  return (
    <Layout navbarVisibility={{ staking: false }}>
      <ClaimPage pool={pool} chain={chain} />
    </Layout>
  );
}

Claim.ignoreDefaultChainSwitch = true;

export async function getStaticProps({ params }) {
  return { props: { id: params.id, chain: params.chain } };
}

export async function getStaticPaths() {
  const paths = Object.values(poolsConfigById)
    .filter(
      (pool) =>
        pool.distribution &&
        (Array.isArray(pool.distribution)
          ? pool.distribution
          : [pool.distribution]
        ).filter((d) => CLAIM_US_TYPES.includes(d.type)).length > 0,
    )
    .flatMap((pool) =>
      (Array.isArray(pool.distribution)
        ? pool.distribution
        : [pool.distribution]
      ).map((distr) => ({
        params: { id: pool.id, chain: distr.network || 'BSC' },
      })),
    );

  return { paths, fallback: false };
}
